// extracted by mini-css-extract-plugin
export default {"toggleButtonGroup":"ToggleButtonForm_toggleButtonGroup__NwKzi","group":"ToggleButtonForm_group__HiFXW"};